import React from 'react'
import LoadingBar from 'react-redux-loading-bar'

import {  
	showLoading, 
	hideLoading 
} from 'react-redux-loading-bar' 


var CustomLoadingBar = (props) => (
	<LoadingBar className="LoadingBar" updateTime={400} maxProgress={95} progressIncrease={5} {...props} />
);

export default CustomLoadingBar

var count = 0;

const loadingBarMiddleware = store => next => action => {

	// TODO: make login redirect work with loading bar properly
	// if(action.type === 'AUTH_LOGIN_REQUEST') {
	// 	return next(action);
	// }

	// var state = store.getState();

	var regex = /([A-Z]*)_([A-Z]*)_(REQUEST|FAILURE|SUCCESS)/g;

	if(regex.test(action.type)) {
		// 0:resource, 1:verb, 2:type
		var type = action.type.split('_')[2];
		
		switch(type) {
			case 'REQUEST':
				if(!count) {
					store.dispatch(showLoading());
				}
			 	count++;
				break;
			case 'SUCCESS':
			case 'FAILURE':
				count--;
				if(!count) {
					store.dispatch(hideLoading());
				}
				break;
			default:
				break;
		}
	} else {
		// switch(action.type) {
		// 	case 'API_UNAUTHORIZED':
		// 		count = 0;
		// 		store.dispatch(hideLoading());
		// 		break;
		// }
	}

	return next(action);
}

export {loadingBarMiddleware};



// WEBPACK FOOTER //
// ./src/modules/loading-bar/loading-bar.js